var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('module',{attrs:{"enable-flex":""}},[_c('empty',{staticClass:"flex-grow",attrs:{"icon":"build","message":"正在建设中，敬请期待！"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }